import { h } from "preact";




export default function Blank({ }) {

    return (
        <div style="padding: 20px;">
            <script>

                document.body.style.display = "none";

            </script>

        </div>
    );
}